import React from 'react';
import { useI18n } from '../i18n/I18nProvider.jsx';

export default function FAQ() {
  const { t } = useI18n();
  const items = t('faq.items');
  return (
    <section className="faq-section">
      <div className="fone-top"></div>
      <div className="faq-inner">
        <span className="section-tag">{t('faq.tag')}</span>
        <h2 className="section-title" style={{ marginBottom: 40 }}>{t('faq.title')}</h2>
        <div className="faq-list">
          {Array.isArray(items) && items.map((item, i) => (
            <details className="faq-item" key={i} open={i === 0}>
              <summary>
                {item.q}
                <span className="faq-arrow"></span>
              </summary>
              <div className="faq-body">{item.a}</div>
            </details>
          ))}
        </div>
      </div>
      <div className="fone-bottom"></div>
    </section>
  );
}